export const POST_PAYMENT_REPORT_SEARCH = 'POST_PAYMENT_REPORT_SEARCH';
export const POST_PAYMENT_REPORT_EXPORT_EXCEL = 'POST_PAYMENT_REPORT_EXPORT_EXCEL';
export const GET_REPORTING_ORGANISATIONS = `GET_REPORTING_ORGANISATIONS`;
export const GET_TRANSACTION_TYPES = `GET_TRANSACTION_TYPES`;
export const GET_EXAM_LEVELS = `GET_EXAM_LEVELS`;
export const GET_CHECK_ELIGIBILITY = 'GET_PAYMENT_REPORT_CHECK_ELIGIBILITY';
export const GET_PAYMENT_STATUSES = `GET_PAYMENT_STATUSES`;
